const fitText = (el: HTMLElement) => {
	let fontSize = parseInt(window.getComputedStyle(el).getPropertyValue('font-size'));

	while (el.scrollWidth > el.clientWidth) {
		el.style.fontSize = (fontSize -= 0.5) + 'px';
	}
};

export default fitText;
